// Cookieless page views (spec §15.2). Nothing is stored in the browser; the
// server keeps the page, the referring site and campaign tags, and a visitor
// hash that changes every day. Do Not Track and Global Privacy Control are respected.
const TAGS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;

const optedOut = () =>
  navigator.doNotTrack === '1' || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;

export function trackPageView(): void {
  if (optedOut()) return;
  const params = new URLSearchParams(location.search);
  const body: Record<string, unknown> = { path: location.pathname, signup: params.has('signup'), referrer: document.referrer };
  for (const t of TAGS) if (params.get(t)) body[t] = params.get(t);
  void fetch('/api/t', {
    method: 'POST', keepalive: true, credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  }).catch(() => {});
}

/**
 * Where this visit came from (an outside referrer, campaign tags), to carry
 * into sign-up links so a new account can be credited to its source, again
 * without storing anything.
 */
export function visitSource(): Record<string, string> {
  if (optedOut()) return {};
  const params = new URLSearchParams(location.search);
  const out: Record<string, string> = {};
  for (const k of ['ref', ...TAGS]) {
    const v = params.get(k);
    if (v) out[k] = v.slice(0, 100);
  }
  if (!out.ref && document.referrer) {
    try {
      const u = new URL(document.referrer);
      if (u.origin !== location.origin) out.ref = u.hostname;
    } catch { /* ignore */ }
  }
  return out;
}

/** A same-site link with this visit's source added. */
export function withSource(href: string): string {
  const u = new URL(href, location.origin);
  for (const [k, v] of Object.entries(visitSource())) u.searchParams.set(k, v);
  return u.pathname + u.search;
}
